import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomBuildBasicRichTextEditorComponent } from './rich-text-editor.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { FormsModule } from '@angular/forms';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CKEditorModule,
  ],
  declarations: [
    CustomBuildBasicRichTextEditorComponent
  ],
  exports: [
    CustomBuildBasicRichTextEditorComponent
  ],
})
export class RichTextEditorBasicCustomBuildModule { }
